"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shiftNames = void 0;
const shiftNames = {
  SHIFT: 'shift',
  SHIFT_VTO: 'shift_vto',
  OPEN_SHIFT: 'open_shift',
  SHIFT_INVENTORY: 'shift_inventory',
  SHIFT_PICKUP: 'shift_pickup'
};
exports.shiftNames = shiftNames;